<ion-input
  type="text"
  inputmode="decimal"
  [formControl]="formControl"
  (ionInput)="inputChanged()"
  [required]="config?.required ?? false"
  [readonly]="config?.readonly ?? false"
  [placeholder]="config?.placeholder"
  [maskito]="options"
  [maskitoElement]="elementPredicate"
>
</ion-input>
